import React, { useState } from 'react';
import DeleteAccountModal from './DeleteAccountModal';

const DeleteAccountSection = () => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteStep, setDeleteStep] = useState('confirm');
  const [verificationCode, setVerificationCode] = useState('');
  const [feedback, setFeedback] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setDeleteError] = useState('');

  const handleOpenDeleteModal = () => {
    setIsDeleteModalOpen(true);
    setDeleteStep('confirm');
    setVerificationCode('');
    setFeedback('');
    setDeleteError('');
  };

  return (
    <div className="rounded-lg p-6 mb-6">      
      <div className="flex justify-center">
        <button
          onClick={handleOpenDeleteModal}
          className="px-4 py-2 bg-white text-red-500 rounded transition-colors"
          type="button"
        >
          Delete account
        </button>
      </div>

      <DeleteAccountModal
        isOpen={isDeleteModalOpen}
        setIsDeleteModalOpen={setIsDeleteModalOpen}
        verificationCode={verificationCode}
        setVerificationCode={setVerificationCode}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        error={error}
        setDeleteError={setDeleteError}
        deleteStep={deleteStep}
        setDeleteStep={setDeleteStep}
        feedback={feedback}
        setFeedback={setFeedback}
      />
    </div>
  );
};

export default DeleteAccountSection;
